import React, { useContext } from 'react';
import projectContext from '../../context/projects/projectContext';
import taskContext from '../../context/tasks/taskContext';

const Project = ({ project }) => {
    const projectsContext = useContext(projectContext);
    const { actualProject } = projectsContext;

    // Get the context of task
    const tasksContext = useContext(taskContext);
    const { getTasks } = tasksContext;

    // Function to add the actual project
    const selectProject = id => {
        actualProject(id); // Set an actual project
        getTasks(id); // Filter the task when click
    }

    return ( 
        <li>
            <button
                type="button"
                className="btn btn-blank"
                onClick={ () => selectProject(project._id) }
            >
                { project.name }
            </button>
        </li>
     );
}
 
export default Project;